import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import config from 'config'
import { connect } from 'react-redux'
import scriptLoader from 'react-async-script-loader'
import { extractNumber } from '@cred/shared/utils'
import Pagination from 'components/styled-pagination'
import { useViewport } from 'components/hooks'
import FilterModal from '../components/filter-modal'
import HYSFilterForm from './components/hys-filter-form'
import HYSLendersList from './components/lenders-list'
import {
  resetFilters,
  generateFilterText,
  generateUpdate,
  getPageStats,
  getPartnerDefaultFilterValues,
} from '../utils'
import { loadLenders } from './components/lenders-data'

const formName = 'HYS-filter-form',
  TABLET = 568,
  paginationName = 'HYS-rate-table',
  getTilePerPage = () => {
    const width = useViewport()

    return width >= TABLET ? 3 : 2
  },
  initialBalance = {
    balanceAmount: '$10,000',
  },
  HYSRateTable = ({
    formFilterValues,
    variation,
    page,
    widgetContext,
    defaultFilterValues,
    ...props
  }) => {
    const [filterValues, setFilterValues] = useState(defaultFilterValues),
      lenders = loadLenders(props),
      balanceAmount = extractNumber(filterValues.balanceAmount),
      { pageCount, pageFrom, pageTo, showPagination } = getPageStats(variation, lenders, page, getTilePerPage())

    return (
      <div>
        <FilterModal formName={formName} filterText={generateFilterText(filterValues, 'high-yield-savings')}>
          {({ closeModal }) => (
            <HYSFilterForm
              form={formName}
              withFooter
              initialValues={filterValues}
              closeModal={closeModal}
              update={generateUpdate(formFilterValues, setFilterValues, closeModal)}
            />
          )}
        </FilterModal>
        <HYSLendersList
          lenders={lenders}
          pageFrom={pageFrom}
          pageTo={pageTo}
          balanceAmount={balanceAmount}
          resetFilters={resetFilters(setFilterValues, initialBalance)}
        />
        { showPagination && (
          <Pagination
            pageCount={pageCount}
            name={paginationName}
          />
        )}
      </div>
    )
  },
  mapStateToProps = (state, ownProps) => ({
    formFilterValues: state.form[formName],
    page: state.components.pagination[paginationName],
    defaultFilterValues: {
      ...initialBalance,
      ...getPartnerDefaultFilterValues(ownProps.widgetContext, 'high-yield-savings'),
    },
  })

HYSRateTable.propTypes = {
  formFilterValues: PropTypes.object,
  isScriptLoaded: PropTypes.bool,
  variation: PropTypes.string,
  page: PropTypes.number,
  isScriptLoadSucceed: PropTypes.bool,
  balanceAmount: PropTypes.number,
  widgetContext: PropTypes.object,
  defaultFilterValues: PropTypes.shape({
    balanceAmount: PropTypes.string,
  }),
}

HYSRateTable.defaultProps = {
  page: 0,
}

export { HYSRateTable }

export default compose(
  scriptLoader(config.ratesLibraryUrl),
  connect(mapStateToProps),
)(HYSRateTable)
